module.exports = __webpack_public_path__ + "img/img_brand2.adb8fb11.jpg";